/** "Anna Kaiser" from "anna.kaiser@finn.com": the proxy knows people by their address only. */
export const nameFromEmail = (email: string | null | undefined) =>
  email
    ? email.split('@')[0].split(/[._-]+/).filter(Boolean).map((p) => p[0].toUpperCase() + p.slice(1)).join(' ')
    : 'someone';

/** "Marked done by Anna Kaiser on 15 Oct 2026". */
export const markedDoneText = (mark: { by: string | null; at: string | null }) =>
  `Marked done by ${nameFromEmail(mark.by)}${mark.at ? ` on ${formatDate(mark.at)}` : ''}`;

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

/**
 * "30 Sep 2026" from an ISO date or timestamp; "–" for none. A date with no time (a termination
 * date) is a calendar day and is read in UTC: parsed as midnight UTC and shown in local time, a
 * browser west of UTC would print the day before. A timestamp (a request's `created`) stays local.
 */
export const formatDate = (iso: string | null) =>
  iso
    ? new Date(iso).toLocaleDateString('en-GB', {
      day: 'numeric', month: 'short', year: 'numeric', ...(DATE_ONLY.test(iso) ? { timeZone: 'UTC' } : {}),
    })
    : '–';
